"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var response_1 = require("./response");
exports.SoFetchResponse = response_1.default;
var so_fetch_1 = require("./so-fetch");
var defaultFetch = function (url, options) {
    if (options === void 0) { options = {}; }
    return new so_fetch_1.default({}).fetch(url, options);
};
var makeFetchClient = function (args) {
    return new so_fetch_1.default(args);
};
exports.makeFetchClient = makeFetchClient;
exports.default = defaultFetch;
//# sourceMappingURL=index.js.map